var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0619 15.3872H3.33321C2.11862 15.3872 1.04256 16.3821 1.08314 17.5967C1.11813 18.0682 1.24266 18.8029 1.82617 18.8239H20.3194L20.3418 15.667C20.346 15.5201 20.2088 15.383 20.0619 15.3872Z",
    fill: "url(#paint0_linear_712_1003)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32217 20.2428C0.975146 20.8515 0.902373 22.409 1.80635 22.5349H20.3107V19.9434H1.81315C1.60746 19.9434 1.41993 20.0609 1.32339 20.2428L1.32217 20.2428Z",
    fill: "url(#paint1_linear_712_1003)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87039 14.6943H13.2749C13.5114 14.6943 13.7381 14.5796 13.864 14.3809C16.0259 10.9609 13.7437 7.23038 13.5632 6.74499L11.516 2.62256L9.51638 6.6386C9.30509 7.15494 7.05919 11.0003 9.28549 14.3909C9.41283 14.584 9.63672 14.6945 9.869 14.6945L9.87039 14.6943Z",
    fill: "url(#paint2_linear_712_1003)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2023 13.7626C16.6016 12.5536 17.2327 10.7136 17.2369 8.96855C17.423 6.6219 17.9603 5.72914 19.0826 4.45709C16.9948 4.04431 15.2023 5.79064 14.4887 6.62183C14.4803 6.62743 14.5965 6.82893 14.5951 6.83452C14.6776 6.99404 16.5177 10.5145 15.2024 13.764L15.2023 13.7626Z",
    fill: "url(#paint3_linear_712_1003)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5597 6.74497C20.5214 6.27341 19.3949 6.14327 18.9234 6.11389C18.5512 6.7338 18.1691 7.68251 18.1216 8.99787C18.123 10.5133 17.685 12.0204 16.7656 13.3567C18.1985 12.5717 19.2368 10.8799 19.248 10.8618C19.8609 9.68215 20.6935 8.70266 21.701 7.97221C22.1362 7.68535 22.0466 6.93949 21.5597 6.74497Z",
    fill: "url(#paint4_linear_712_1003)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82083 10.8785C3.82642 10.8841 4.82274 12.5059 6.23324 13.2853C5.33629 11.9196 4.95847 10.6323 4.94167 8.99241C4.89409 7.67146 4.50507 6.72134 4.14545 6.11401C3.49617 6.16019 1.72605 6.36589 0.524172 7.3286C0.490588 7.36219 0.48639 7.42376 0.54796 7.45874C1.31477 7.86593 2.76575 8.85091 3.82083 10.8785Z",
    fill: "url(#paint5_linear_712_1003)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70557 5.36513C5.22611 6.14455 5.74385 7.21782 5.82642 8.96849C5.82222 10.7932 6.51349 12.7062 7.94359 13.7988C6.56948 10.537 8.35078 6.9997 8.43894 6.82739L8.55088 6.6035C7.8666 5.82548 6.05593 4.04418 3.95703 4.46255C4.2271 4.69483 4.48731 5.01532 4.70557 5.36513Z",
    fill: "url(#paint6_linear_712_1003)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8152 13.7246C33.5409 13.288 33.1659 12.885 32.6789 12.5156C32.6789 12.5156 24.0257 12.517 23.8018 12.5156C22.6222 13.3972 21.9981 14.6776 21.9883 16.109V17.29H34.4924C34.5246 16.095 34.5134 14.7475 33.8152 13.7246Z",
    fill: "url(#paint7_linear_712_1003)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9883 18.4099V29.7724C21.9883 30.6791 22.7215 31.4124 23.6283 31.4124H32.8525C33.7592 31.4124 34.4925 30.6791 34.4925 29.7724V18.4099H21.9883Z",
    fill: "url(#paint8_linear_712_1003)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6867 9.2189C24.6769 9.52675 24.7077 11.1024 24.6755 11.3962C24.4278 11.4004 31.812 11.3962 31.812 11.3962C31.7658 11.0674 31.8106 9.57712 31.7952 9.2357C33.4758 8.50808 32.951 5.92074 31.0955 5.92773H30.3399V2.60858C30.2657 -0.150849 26.2569 -0.110263 26.1867 2.60858V5.92773H25.4255C23.5993 5.91933 23.0537 8.45907 24.6867 9.2189Z",
    fill: "url(#paint9_linear_712_1003)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89416 23.6542C2.51495 23.6528 2.14695 23.8026 1.88806 24.0796C-0.823797 26.7173 1.14643 31.4905 4.92736 31.4454H19.4132C19.7364 31.416 20.264 31.4538 20.3143 31.0592V27.7736H6.14625C5.41863 27.7722 5.41021 26.657 6.14625 26.6542H20.3129V23.6541L2.89416 23.6542Z",
    fill: "url(#paint10_linear_712_1003)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_712_1003",
    x1: 10.712,
    y1: 15.3871,
    x2: 10.712,
    y2: 21.2941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_712_1003",
    x1: 10.6964,
    y1: 19.9434,
    x2: 10.6964,
    y2: 24.3975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_712_1003",
    x1: 11.5487,
    y1: 2.62256,
    x2: 11.5487,
    y2: 23.3713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_712_1003",
    x1: 16.7854,
    y1: 4.3949,
    x2: 16.7854,
    y2: 20.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_712_1003",
    x1: 19.3736,
    y1: 6.11389,
    x2: 19.3736,
    y2: 18.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_712_1003",
    x1: 3.36662,
    y1: 6.11401,
    x2: 3.36662,
    y2: 18.4397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_712_1003",
    x1: 6.25396,
    y1: 4.39978,
    x2: 6.25396,
    y2: 20.5543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_712_1003",
    x1: 28.2451,
    y1: 12.5156,
    x2: 28.2451,
    y2: 20.7216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_712_1003",
    x1: 28.2404,
    y1: 18.4099,
    x2: 28.2404,
    y2: 40.7579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_712_1003",
    x1: 28.2627,
    y1: 0.554199,
    x2: 28.2627,
    y2: 19.1921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_712_1003",
    x1: 10.4716,
    y1: 23.6541,
    x2: 10.4716,
    y2: 37.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpas);
export default __webpack_public_path__ + "static/media/spas.de462e8959c5b6b92b5eb3f48403d4fb.svg";
export { ForwardRef as ReactComponent };